/**
 *  海关信函
 * @author FJJ
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2022/09/14      1.0    First version   使用统一的表格组件
 *
 * @copyright 2021-2022, all rights reserved. Essa.cn
 * */

import React,{Fragment} from 'react'
import { Button, Spin,Empty, message} from 'antd';
import Lang from "@components/Lang/Lang";
import PropTypes from "prop-types";
import dayjs from "dayjs";
import {toFixed2,isEmpty} from '@utils/utils';
import DownloadBtnModal from "./common/DownloadBtnModal";
import HistoryBtnModal from './common/HistoryBtnModal';
import ConfirmAlert from './common/ConfirmAlert';
import FormFormat from '@components/FormFormat/FormFormat';
import ShipperManagementAction from "../../ShipperManagement.action";
import HistoryTop from "./common/HistoryTop";
import PageCommon from  "@components/PageCommon/PageCommon";

export default class CustomsLetterEdit extends React.Component{
    static propTypes = {
        orderType: PropTypes.string.isRequired,
    }
    static defaultProps = {
        orderType:'',
    }
    constructor(props) {
        super(props);
        this.state = {
            list:[],
            orderInfo: {},
            loading:false,
            //历史记录面板
            isShowHistoryPanel:false,
            isShowHistoryId:null,
            // 编辑
            editOption:[
                {
                    type:'TextArea',
                    name:'letterContent',  // 内容
                    size:4,
                    cnPlaceholder:'请输入',
                    cnPlaceholderId:'QingShuRu',
                    required:true
                },
                {
                    type:'Date',
                    name:'letterTime', // 日期
                    maxLength:100,
                    cnPlaceholder:'请选择……',
                    cnPlaceholderId:'QingXuanZe',
                    required:true
                },
            ],
            canEdit:false,
        }
    }
    getData(){
        this.fetch(this.props.containerId)
    }
    /**
     * 展示历史记录面板
     * @param item
     */
    showHistoryPanel(item){
        this.setState({
            isShowHistoryPanel:true,
            orderInfo: {},
        },()=>this.fetch('',item.id))

    }

    /**
     * 隐藏历史记录面板
     **/
    hideHistoryPanel(){
        this.setState({
            isShowHistoryPanel:false,
            orderInfo: {},
        },()=>this.fetch(this.props.containerId))
    }
    /**
     * 加载状态
     * */
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    /**
     * 设置 信息头
     * */
    handleRes(res,isShowHistoryId){
        this.loading(false)
        const {success,valid} = res;
        if(success&&valid){
            this.setState({
                orderInfo:res.model||{},
                isShowHistoryId:isShowHistoryId,
            })
        }else{
            if(res.message){
                message.warning(res.message);
            } else message.warning(Lang({id:'CaoZuoShiBai',default: "操作失败",}));
        }
    }
    onRefTabOne = (ref) =>  this.onRefTabChildOne = ref;
    /**
     * 进入请求
     * */
    fetch(sContainerId,sId){
        let postData = {}
        if(!isEmpty(sContainerId)){
            postData = {
                containerId: sContainerId,
            }
        }
        if(!isEmpty(sId)){
            postData = {
                id: sId,
            }
        }
        this.loading(true)
        ShipperManagementAction.autoFetchAction(postData,'/service/mg/con/report/customs-letter/details').then(res=>this.handleRes(res.data,sId)).catch(err=>this.handleRes(err))
    }
    /**
     * 编辑
     * */
    edit(flag=true){
        this.setState({
            canEdit: flag
        })
        this.props.handleEdit(flag)
    }
    async save(){
        const res = await this.onRefFormFormat.handleOK();
        if(res.success){
            this.loading(true)
            let postData = {...res.data}
            const { orderInfo } = this.state;
            postData['containerId'] = this.props.containerId;
            postData['version'] = orderInfo.version;
            ShipperManagementAction.autoFetchAction(postData,'/service/mg/con/report/customs-letter/save').then(res=>this.handleSaveRes(res.data)).catch(err=>this.handleSaveRes(err))
        }
    }
    handleSaveRes(res){
        this.loading(false)
        const {success,valid} = res;
        if(success&&valid){
            message.success(Lang({id:'CaoZuoChengGong',default: "操作成功",}));
            this.fetch(this.props.containerId)
            this.edit(false)
        }else{
            if(res.message){
                message.warning(res.message);
            } else message.warning(Lang({id:'CaoZuoShiBai',default: "操作失败",}));
        }
    }
    onRefForm = (ref) =>  this.onRefFormFormat = ref;
    onRefPageCommon = (ref) => this.onRefPageCommonChild = ref; 
    componentDidMount() {
        this.fetch(this.props.containerId)
        if(this.props.onRef)this.props.onRef(this);
    }
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }
    render(){
        const { orderInfo,loading, isShowHistoryPanel,canEdit,editOption, } = this.state;
        const {orderType,containerId,downloadUrlPdf} = this.props;
        const pageTitle = Lang({id: 'HaiGuanXinHan', default: '海关信函'})

        let btnList = [];
        if(!isShowHistoryPanel && !canEdit){
            btnList = [
                { 
                    btn: <div>{Lang({id: "BianJi",default: "编辑"})}</div>,
                    icon:"ri-quill-pen-line color-blue mr_4",
                    btnClick:()=>this.edit()
                },{ 
                    btn: <DownloadBtnModal title={<div>
                        <i className='ri-download-2-line color-danger mr_4'></i>
                        {Lang({id: "XiaZaiGaiZhangPDF",default: "下载盖章PDF"})}
                    </div>}
                    downloadUrl={downloadUrlPdf}
                    orderInfo={orderInfo} type={'pdf'} />,
                    btnClick:()=>{}
                },{ 
                    btn: <HistoryBtnModal className={"margin-left-5"}
                    title={Lang({id: 'LiShiJiLu', default: '历史记录'})}
                    orderType={orderType}
                    recoveryHistoryBack={this.getData.bind(this)}
                    showHistoryPanel={item=>this.showHistoryPanel(item)}
                    containerId={containerId} />,
                    btnClick:()=>{}
                }
            ]
    
            if(orderInfo.status === '10' || orderInfo.status === '20'){
                btnList.push({
                    btn: <ConfirmAlert orderInfo={orderInfo} orderType={orderType} callBack={()=>this.getData()} />,
                    btnClick:()=>{}
                })
            }
        }


        return ( 
            <PageCommon onRef={this.onRefPageCommon} className={"transferWrap"} btnList={btnList}>
                <Spin spinning={loading}>
                    <div className={"packListWrap"}>
                        {orderInfo.id&&!isShowHistoryPanel&&!canEdit&&<div>
                            {/*操作区*/}
                            <div className={"flex-item fixed-footer__wrap"}>
                                {/*<DownloadBtnModal title={Lang({id: "XiaZaiExcel",default: "下载Excel"})}*/}
                                                {/*downloadUrl={downloadUrlExcel}*/}
                                                {/*orderInfo={orderInfo} />*/}
                                {/* <Button  onClick={()=>this.edit()}>{Lang({id: "BianJi",default: "编辑"})}</Button>
                                <DownloadBtnModal title={Lang({id: "XiaZaiGaiZhangPDF",default: "下载盖章PDF"})}
                                                type={'pdf'}
                                                className={"margin-left-5"}
                                                downloadUrl={downloadUrlPdf}
                                                orderInfo={orderInfo} />
                                <HistoryBtnModal className={"margin-left-5"}
                                                title={
                                                    pageTitle  + Lang({id: 'LiShiJiLu', default: '历史记录'})
                                                }
                                                showRecover={true}
                                                recoverUrl={"/service/mg/con/report/customs-letter/recovery-version"}
                                                recoveryHistoryBack={(res)=>this.fetch(containerId)}
                                                showHistoryPanel={item=>this.showHistoryPanel(item)}
                                                orderType={orderType}
                                                containerId={containerId} />
                                <ConfirmAlert orderInfo={orderInfo} orderType={orderType} callBack={()=>this.getData()} /> */}
                            </div>
                        </div>}
                            {isShowHistoryPanel&&<HistoryTop title={pageTitle}
                                                            showRecover={true}
                                                            recoverUrl={"/service/mg/con/report/customs-letter/recovery-version"}
                                                            recoveryHistoryBack={(res)=>this.hideHistoryPanel(containerId)}
                                                            callBack={()=>this.hideHistoryPanel()}
                                                            orderInfo={orderInfo} />}
                            {/* 公共内容 */}
                            {orderInfo&&orderInfo.id&&<div className={"borderWrap margin_bottom_20"}>
                                <div className={"text-center padding-bottom-10"}>
                                    <p className={"font-20 color-black"}>{orderInfo.companyNameEn}</p>
                                    <p className={"font-16 padding-top-10"}>{orderInfo.companyNameZh}</p>
                                    <p className={"padding-top-10"}>{orderInfo.companyAddress}</p>
                                </div>
                                {canEdit?<FormFormat onRef={this.onRefForm}
                                                options={editOption}
                                                formLayout = "vertical"
                                                className={'form-format-white'}
                                                initialValues={{
                                                    letterContent:orderInfo.letterContent,
                                                    letterTime: orderInfo.letterTime?dayjs(orderInfo.letterTime):''
                                                }} />:<>
                                    <div className="padding-top-10 padding-bottom-10"
                                        dangerouslySetInnerHTML = {{__html: orderInfo.letterContent?orderInfo.letterContent.replace(new RegExp('\n','g'),'<br/>'):'-' }} >
                                    </div>
                                    <p className="padding-top-10 padding-bottom-10">{orderInfo.letterTime?dayjs(orderInfo.letterTime).format("YYYY-MM-DD "):'-'}</p>
                                </>}
                            </div>}
                        {canEdit&&<div className={"text-center"}>
                            <Button type="primary" onClick={()=>this.save()}>{Lang({id: "QueDing",default: "确定"})}</Button>
                            <Button className={"margin-left-5"} onClick={()=>this.edit(false)}>{Lang({id: "QuXiao",default: "取消"})}</Button>
                        </div>}
                        {/* 公共内容 END */}
                        {!orderInfo.id&&<div className={"bar"}>
                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                        </div>}
                    </div>
                </Spin>
            </PageCommon>
        )
    }
}
